import { v4 as uuidv4 } from 'uuid';
/* eslint no-param-reassign: "error" */
export default (file) => {
  const imageId = uuidv4();
  file.renamedFilename = `${imageId}.${file.name.split('.').pop()}`;
  file.id = imageId;
  return file;
};
